import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { Check } from "../../models/check";
import { GiftBalanceResponseDTO, GiftProcessedDTO } from "../../models/DTO/giftcard.dto";
import { LogLevel } from "../../models/enums/log-level.enum";

@Component({
	selector: "app-gift-card-payment",
	templateUrl: "./gift-card-payment.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class GiftCardPaymentComponent implements OnInit {
	@Input() check: Check;
	@Input() tip: number;
	@Input() total: number;
	@Input() venueKey: number;

	@Output() giftProcessed: EventEmitter<GiftProcessedDTO> = new EventEmitter<GiftProcessedDTO>();

	detailMessage: string;
	giftCardNumber: string;
	giftCardBalance: number;

	saving: boolean = false;

	zeroBalance: boolean = false;

	constructor(public app: AppService, private confirmationService: ConfirmationService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}

	async balanceCheck(giftCardNumber): Promise<GiftBalanceResponseDTO> {
		this.app.loading(true);
		const resp = await this.focuslink.getGiftBalance(this.venueKey, giftCardNumber);
		this.app.loading(false);
		return new GiftBalanceResponseDTO(resp);
	}

	async processBalanceCheck(giftCardNumber) {
		try {
			const balanceResp = await this.balanceCheck(giftCardNumber);

			const checkTotalWithTip = this.total;
			this.giftCardBalance = balanceResp.balance;

			const remainingBalance = this.giftCardBalance - checkTotalWithTip;

			let available = 0;
			if (remainingBalance >= 0) {
				available = checkTotalWithTip;
			} else {
				available = this.giftCardBalance;
			}

			available = +(Math.round(available * 100) / 100).toFixed(2);
			console.log(available);
			if (available === 0) {
				this.zeroBalance = true;
				return;
			}

			this.app.msgSvc.clear();
			this.promptGcBalance(giftCardNumber, available);
		} catch (error) {
			this.app.loading(false);
			this.detailMessage = "Error processing gift card.";
			if (error?.error?.detail) {
				switch (error.error.detail) {
					case "Account not found":
						this.detailMessage = "Invalid or inactive gift card.";
						break;
					case "Insufficient balance.":
						this.detailMessage = "Insufficient funds on gift card.";
					default:
						this.detailMessage = this.detailMessage;
				}
			}
			this.app.log(LogLevel.ERROR, "gift-balance", this.venueKey, {
				errorDetails: {
					name: error.name,
					message: error.message,
					code: error.code,
					detail: error.detail,
					stack: error.stack,
				},
			});

			this.app.msgSvc.add({
				severity: "error",
				detail: this.detailMessage,
				key: "sidebar",
			});
		}
	}

	promptGcBalance(cardNumber, available) {
		this.app.confirmation.confirm({
			header: `Gift Card Balance: $${this.giftCardBalance.toFixed(2)}`,
			message: `Apply $${available} from your gift card to this order?`,
			accept: async () => {
				console.log("accepted");
				this.giftProcessed.emit(
					new GiftProcessedDTO({
						accountNumber: cardNumber,
						appliedAmount: available,
						balanceAmount: this.giftCardBalance,
					})
				);
				this.app.confirmation.close();
			},
			reject: async () => {
				this.giftCardBalance = undefined;
				this.app.confirmation.close();
			},
		});
	}
}
